import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import { Question } from '../../interfaces/questionInterface';
import { QuestionService } from '../../services/question.service';

@Component({
    selector: 'app-feedback',
    imports: [ModalComponent],
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.scss'
})
export class FeedbackComponent {
  @Input() question: Question | undefined;

  @ViewChild('feedbackModal')
  private feedbackModal!: ModalComponent;

  @ViewChild('feedbackModalTextArea')
  private feedbackModalTextArea!: ElementRef<HTMLTextAreaElement>;

  public feedbackText = '';

  public feedbackResult: 'success' | 'error' | undefined;

  constructor(private questionService: QuestionService) { }

  public toggleFeedbackModal(): void {
    this.feedbackResult = undefined;
    this.feedbackModal.toggleModal();
  }

  handleFeedbackInput(): void {
    this.feedbackText = this.feedbackModalTextArea.nativeElement.value;
  }

  async submitFeedback(): Promise<void> {
    if (this.question) {
      this.feedbackModalTextArea.nativeElement.value = '';
      try {
        await this.questionService.submitQuestionFeedback(this.question, this.feedbackText);
        this.feedbackResult = 'success';
      } catch (error) {
        this.feedbackResult = 'error';
      }
    }
  }
}
